import { skipToken, useQuery } from "@tanstack/react-query";

import { preloadDocumentEditor } from "../knowledge/preload-editor";
import { getOpsDocsBootstrap, getOpsDocsPage } from "./docs-api";

export const docsBootstrapOptions = () => ({
  queryKey: ["ops", "docs", "bootstrap"] as const,
  queryFn: getOpsDocsBootstrap,
});

export function useDocsPageQuery(pageId: string | null) {
  return useQuery({
    queryKey: ["ops", "docs", "page", pageId],
    queryFn:
      pageId === null
        ? skipToken
        : () => {
            void preloadDocumentEditor();
            return getOpsDocsPage(pageId);
          },
    refetchInterval: (query) =>
      query.state.data?.page?.searchStatus === "pending" ? 3_000 : false,
    refetchIntervalInBackground: false,
  });
}
